export default "__VITE_ASSET__C2dUk4EN__"